AFRAME.registerComponent('click-button', {
  schema: {
    on: {type: 'string'},
	answer: {type: 'string', default: "z"},
	text: {type: 'string'},
	sceneid: {type: 'string'} 
  },
  
  
  init: function () {
    var data = this.data;
	var el = this.el;
	
	el.addEventListener(data.on, OnButtonClicked);
	
	function OnButtonClicked()
	{
		var answer = data.answer;
		var sceneid = data.sceneid;
		
		var answerGiven = new CustomEvent("answerGiven", {
			"detail": {"answer":answer, "sceneid": sceneid}
			});

		document.dispatchEvent(answerGiven);
	}
  } 
});
